import React from 'react';
import type { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';

import { CalendarStyleOverrides, CalendarStyleVariables } from './styles.ts';

export const CalendarStyles: React.FC = React.memo(function CalendarStyles() {
  return (
    <>
      <CalendarStyleOverrides $styled={{ variant: 'create' }} />
      <CalendarStyleVariables />
    </>
  );
});

export const Calendar: React.FC<CalendarOptions> = React.memo(function Calendar(props) {
  return <FullCalendar plugins={[dayGridPlugin, listPlugin, timeGridPlugin]} initialView='dayGridMonth' firstDay={1} {...props} />;
});
